import Vue from 'vue'

//state
const state = {
	menuModuleSelectedMenu:{},
    tabs:[],
    //组件缓存迁入ComponentContentCache.js
	//tabViewComps:[],
	//tabViewMap:new Map(),
    selectedTab:null,

    keepPages:[],
    leftPaneFold:false,
}

// getters
const getters = {
	getMenuModuleSelectedMenu(state){
		return state.menuModuleSelectedMenu;
	},
	getTabs(state){
		return state.tabs;
    },
    getLeftPaneFold(state){
        return state.leftPaneFold;
    },
    //组件缓存功能迁入ComponentContentCache.js
    /*
	getTabViewComps(state){
		return state.tabViewComps;
	},
	getTabViewComp(state,tabViewCompId){
		return function(tabViewCompId){
			return  state.tabViewMap.get(tabViewCompId);
			};
    },
    */
    getTab(state){
        return function(tabId){
            for(var idx in state.tabs){
                if(state.tabs[idx].tabId==tabId)
                    return state.tabs[idx];
            }
            return  null;
        };
    },
	getSelectedTab(state){
		return state.selectedTab;
    },
    
    getKeepPages(state){
		return state.keepPages;
    },
}

// actions
const actions = {}

// mutations
const mutations = {
	setMenuModuleSelectedMenu(state,aMenuModuleSelectedMenu){
		state.menuModuleSelectedMenu = aMenuModuleSelectedMenu;		
	},
	setTabs(state,newTabs){
		state.tabs = newTabs;
	},
	addTab(state,tab){
        for(let idx in state.tabs){
            if(state.tabs[idx].tabId==tab.tabId)
                return;
        }
		state.tabs.push(tab);
    },
    setLeftPaneFold(state,fold){
        state.leftPaneFold = fold;
    },
    //组件缓存功能迁入ComponentContentCache.js
    /*
	addTabViewComp(state,tabViewComp){
		state.tabViewComps.push(tabViewComp);
		state.tabViewMap.set (tabViewComp.tabViewCompId,tabViewComp);
	},
	addTabViewComps(state,newComps){
		newComps.forEach(function(tabViewComp){
			state.tabViewComps.push(tabViewComp);
			state.tabViewMap.set (tabViewComp.tabViewCompId,tabViewComp);
        });
    },
    setTabViewCompContent(state,tabViewCompId,tabViewCompContent){
        let tabViewComp = state.tabViewMap.get (tabViewCompId);
        if(tabViewComp)
            tabViewComp.content = tabViewCompContent;
    },
    */
	setSelectedTab(state,selectedTab){
		state.selectedTab = selectedTab;
	},
	setSelectedTabId(state,selectedTabId){
		let tab = state.tabs.find(function(item){
			return item.tabId==selectedTabId; 
		});
		if(tab)
			state.selectedTab = tab;
		else
			throw new Error("tabs find id: ["+selectedTabId+"] failed");
	},
	closeTab(state,tabId){
		let tabs = state.tabs;
		let needClosedIndex = -1;
		for(var i =0;i<tabs.length;++i){
			let tab = tabs[i];
			if(tab.tabId==tabId){
				needClosedIndex = i;
				break;
			}
		}
		
		//删除tab
		if(needClosedIndex!=-1){
			tabs.splice(needClosedIndex,1);	
		}
    },
    
    changeKeepPages(state, pages) {
        state.keepPages = pages;
    },
    keepPage(state, page) {
        if(state.keepPages.indexOf(page)!=-1)
            return;
        state.keepPages.push(page);
    },
    removeKeepPage(state, page) {
        let idx = state.keepPages.indexOf(page);
        if(idx==-1)
            return;
            state.keepPages.splice(idx,1);
    }
    
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
